import { render, staticRenderFns } from "./ProductPreviewLow2View.vue?vue&type=template&id=6ffedc16&scoped=true"
import script from "./ProductPreviewLow2View.vue?vue&type=script&lang=js"
export * from "./ProductPreviewLow2View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffedc16",
  null
  
)

export default component.exports